import { apiService } from './axios.client';

export const AdminEndPoints = {
    getUserList: function (input, callback) {
        apiService.get('/monitor/getUserList', input)
            .then(callback)
            .catch(error => error.response);
    }, 
    searchMonitorJobs: function (input, callback) {
        apiService.post('/monitor/searchMonitorJobs', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    getJobCalcTime: function (input, callback) {
        apiService.get('/monitor/getJobCalcTime', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    getCompanysAndRegionLists: function (input, callback) {
        apiService.get('/User/GetCompanysAndRegionLists', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    addUser: function (input, callback) {
        apiService.post('/User/createUserForm', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    addCom: function (input, callback) {
        apiService.post('/User/createCompany', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
    editCom: function (input, callback) {
        apiService.post('/User/editCompany', input)
            .then((response) => callback(response, input))
            .catch(error => callback(error));
    },
}